import { ReactNode } from 'react';
import { usePaymentsConfig } from '@/services/paymentsConfig/usePaymentsConfig';
import { singleProviderConfigs } from '../../features/paymentSelect/ProviderSelectSingle';
import { monthlyProviderConfigs } from '../../features/paymentSelect/ProviderSelectMonthly';
import { JourneyOptions } from '@/services/journeys/types';

// Combine all provider options possible (once) for both of these journeys - Payin
// implements Stripe in the same way Single does, so we don't need to add it in again:
const currentProviderConfigs = singleProviderConfigs.concat(monthlyProviderConfigs);

interface DataAttributeWrapperProps {
  children: ReactNode;
  cartId: string | null;
  campaignCode: string | null;
  selectedJourney: string | undefined;
  journeyOptions: Partial<JourneyOptions> | undefined;
}

function DataAttributeWrapper({
  children, cartId, campaignCode, selectedJourney, journeyOptions
}: DataAttributeWrapperProps) {
  const { isProviderAvailable } = usePaymentsConfig();
  const providerDataAttributes: Record<string, boolean | null> = {};

  // Typeguarding to keep isProviderAvailable call happy:
  if (selectedJourney === 'single' || selectedJourney === 'monthly' || selectedJourney === 'payin') {
    // Iterate over these providers, checking if each is available for the currently-selected journey,
    // assigning the boolean to our dataAttributes object, forming data-attributes for each with the correct name space:
    currentProviderConfigs.forEach((provider) => {
      // NOTE: Payin doesn't properly work with isProviderAvailable yet (likely down to a required B/E change),
      // so Payin will never return any provider data-attributes here.
      providerDataAttributes[`data-provider--${provider.name.toLowerCase()}`] = isProviderAvailable(selectedJourney, provider.name);
    });
  }

  return (
    <div
      id="data-attribute-wrapper"
      data-cart-id={cartId}
      data-campaign-code={campaignCode}
      // Which journeys are available for this cart:
      data-journey--single={journeyOptions && 'single' in journeyOptions}
      data-journey--monthly={journeyOptions && 'monthly' in journeyOptions}
      data-journey--payin={journeyOptions && 'payin' in journeyOptions}
      // Which payment providers are currently available:
      {...providerDataAttributes}
    >
      { children }
    </div>
  );
}

export default DataAttributeWrapper;
